<template>
  <div class="tv-hls__video-container">
    <video
      ref="video"
      class="video"
      autoplay
      muted
      playsinline
      loop
      :controls="false"
    ></video>
  </div>
</template>

<script>
import Hls from "hls.js";
export default {
  name: "TvHls",
  data() {
    return {
      hls: null,
      refreshInterval: null,
    };
  },
  mounted() {
    this.initializePlayer();
    // Set up periodic refresh every 5 minutes
    this.refreshInterval = setInterval(() => {
      this.initializePlayer();
    }, 5 * 60 * 1000);
  },
  beforeDestroy() {
    if (this.hls) {
      this.hls.destroy();
    }
    if (this.refreshInterval) {
      clearInterval(this.refreshInterval);
    }
  },
  methods: {
    initializePlayer() {
      const video = this.$refs.video;
      if (this.hls) {
        this.hls.destroy();
      }

      this.hls = new Hls();
      this.hls.loadSource(
        "https://livepeercdn.studio/hls/8d33n2at0gq7aud6/index.m3u8"
      );
      this.hls.attachMedia(video);

      // Reset stream-active state; emit false so parent shows fallback
      this.$emit("stream-active", false);

      // Handle HLS.js events
      this.hls.on(Hls.Events.MANIFEST_PARSED, () => {
        video.play().catch(() => {
          // Silent fail for autoplay prevention
        });
      });

      // Video element events — track when playback is actually happening
      video.addEventListener("playing", this.onPlaying);
      video.addEventListener("pause", this.onPause);
      video.addEventListener("waiting", this.onWaiting);
      video.addEventListener("stalled", this.onStalled);
      video.addEventListener("error", this.onError);
    },
    onPlaying() {
      this.$emit("stream-active", true);
    },
    onPause() {
      this.$emit("stream-active", false);
    },
    onWaiting() {
      this.$emit("stream-active", false);
    },
    onStalled() {
      this.$emit("stream-active", false);
    },
    onError() {
      this.$emit("stream-active", false);
    },
  },
};
</script>

<style>
.tv-hls__video-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>
